export const fontMapping: { [key: string]: string } = {
  'Lush Script': 'Allura',
  'Penna Connected': 'Pinyon Script',
  Komu: 'Fjalla One',
  'Proxima Nova': 'Roboto',
} as const;
